/**
 pnpm jest packages/service-console/src/modules/company/__tests__/CompanyConsoleQueries.spec.ts \
 packages/service-console/src/modules/permissions/role/__tests__/RoleList.spec.ts \
 packages/service-console/src/modules/company/mutations/console/__tests__/CompanyAddMutation.spec.ts \
 packages/service-console/src/modules/company/mutations/console/__tests__/CompanyAddMutationWallet.spec.ts \
 packages/service-console/src/modules/company/mutations/console/__tests__/CompanyAddWooviMutation.spec.ts -u

 **/

export const MODULES = {
  ACCOUNT_DELETE: 'ACCOUNT_DELETE',
  ADJUST: 'ADJUST',
  API: 'API',
  BAAS: 'BAAS',
  BANK_ACCOUNT_PER_PIX_KEY: 'BANK_ACCOUNT_PER_PIX_KEY',
  BETA: 'BETA',
  BOLETO: 'BOLETO',
  BOLETO_LIMITS: 'BOLETO_LIMITS',
  CASHBACK: 'CASHBACK',
  CHARGE_INTENT: 'CHARGE_INTENT',
  CHATWOOT: 'CHATWOOT',
  CHECKOUT: 'CHECKOUT',
  CLICK_PIX: 'CLICK_PIX',
  CORE: 'CORE',
  CREDIT_CARD: 'CREDIT_CARD',
  CRYPTO_ACCOUNT: 'CRYPTO_ACCOUNT',
  DEFAULT_TIMEZONE: 'DEFAULT_TIMEZONE',
  DEMO_EVENT: 'DEMO_EVENT',
  DISCOUNT: 'DISCOUNT',
  FRAUD: 'FRAUD',
  FIDUCIA_MIGRATED: 'FIDUCIA_MIGRATED',
  INVOICE: 'INVOICE',
  ITP: 'ITP',
  ITP_RECIPIENT: 'ITP_RECIPIENT',
  LEDGER_BALANCE: 'LEDGER_BALANCE',
  META_PIXEL: 'META_PIXEL',
  MULTI_ACCOUNT: 'MULTI_ACCOUNT',
  NEW_PLATFORM_PLANS: 'NEW_PLATFORM_PLANS',
  NO_VERIFICATION_PIX_KEY_POST: 'NO_VERIFICATION_PIX_KEY_POST',
  OPEN_PIX: 'OPEN_PIX',
  OPENPIX_ADVANCED: 'OPENPIX_ADVANCED',
  PARTNER: 'PARTNER',
  PARTNER_FEE_MAX: 'PARTNER_FEE_MAX',
  PARTNER_WALLET: 'PARTNER_WALLET',
  PARTNER_AUTO_CREATE_WALLET: 'PARTNER_AUTO_CREATE_WALLET',
  PARTNER_INHERIT_FEATURES: 'PARTNER_INHERIT_FEATURES',
  PAY_BILLS: 'PAY_BILLS',
  PAY_PIX_KEY_DIRECT: 'PAY_PIX_KEY_DIRECT',
  PERMISSIONS: 'PERMISSIONS',
  PIX_CONSULT: 'PIX_CONSULT',
  PIX_CREDIARY: 'PIX_CREDIARY',
  PIX_CREDIT: 'PIX_CREDIT',
  PIX_KEY_CHECK: 'PIX_KEY_CHECK',
  PIX_OUT: 'PIX_OUT',
  VERIFY_PIX_IN_LIMIT: 'VERIFY_PIX_IN_LIMIT',
  PIXOUT_APPROVE_API: 'PIXOUT_APPROVE_API',
  PIX_AUTOMATIC: 'PIX_AUTOMATIC',
  PLANNING: 'PLANNING',
  REFUND: 'REFUND',
  ROLLOUT_NEW_CHARGE_CREATE: 'ROLLOUT_NEW_CHARGE_CREATE',
  ROLLOUT_NEW_CHARGE_CREATE_API: 'ROLLOUT_NEW_CHARGE_CREATE_API',
  ROLLOUT_OLD_CHARGE_CREATE: 'ROLLOUT_OLD_CHARGE_CREATE',
  ROLLOUT_SUBACCOUNT_WITHDRAW_MOVEMENT: 'ROLLOUT_SUBACCOUNT_WITHDRAW_MOVEMENT',
  ROLLOUT_COMPANY_PARTNER: 'ROLLOUT_COMPANY_PARTNER',
  ROLLOUT_SHOPIFY_AUTHORIZATION_EXPIRES:
    'ROLLOUT_SHOPIFY_AUTHORIZATION_EXPIRES',
  SHOPIFY_PAYMENT_SESSION_PENDING: 'SHOPIFY_PAYMENT_SESSION_PENDING',
  SHOPIFY_QRCODE_ONSITE: 'SHOPIFY_QRCODE_ONSITE',
  SHOPIFY_CHECKOUT_UI: 'SHOPIFY_CHECKOUT_UI',
  SHOPIFY_CHECKOUT_PLUS: 'SHOPIFY_CHECKOUT_PLUS',
  SPLIT_PARTNER: 'SPLIT_PARTNER',
  SPLIT_PAYMENT: 'SPLIT_PAYMENT',
  SPLIT_PAYMENT_LEDGER: 'SPLIT_PAYMENT_LEDGER',
  SPLIT_SUB_ACCOUNT: 'SPLIT_SUB_ACCOUNT',
  SUBACCOUNT_PIX_KEY_CHECK: 'SUBACCOUNT_PIX_KEY_CHECK',
  SUBACCOUNT_BLOCK_BALANCE: 'SUBACCOUNT_BLOCK_BALANCE',
  SUBSCRIPTION_NEW_CRON_ROLLOUT: 'SUBSCRIPTION_NEW_CRON_ROLLOUT',
  SUBSCRIPTION_PLAN: 'SUBSCRIPTION_PLAN',
  SUPPORT: 'SUPPORT',
  TEMP: 'TEMP',
  VTEX: 'VTEX',
  EMAIL_RECOVER_SALE: 'EMAIL_RECOVER_SALE',
  WHATSAPP_RECOVER_SALE: 'WHATSAPP_RECOVER_SALE',
  DARK_THEME_MODE: 'DARK_THEME_MODE',
  NEW_OG_GRAPH: 'NEW_OG_GRAPH',
  WOOVI_IP: 'WOOVI_IP',
  WOOVI_IP_MIGRATED: 'WOOVI_IP_MIGRATED',
  CREDIT_CARD_STEPS_UI: 'CREDIT_CARD_STEPS_UI',
  ALLOW_AUTOMATIC_WITHDRAWAL_ON_WEEKEND:
    'ALLOW_AUTOMATIC_WITHDRAWAL_ON_WEEKEND',
  ALLOW_AUTOMATIC_WITHDRAWAL_ON_HOLIDAY:
    'ALLOW_AUTOMATIC_WITHDRAWAL_ON_HOLIDAY',
  APPLY_AUTOMATIC_WITHDRAWAL_FEE: 'APPLY_AUTOMATIC_WITHDRAWAL_FEE',

  ANALYTICS_BY_TIME: 'ANALYTICS_BY_TIME', // calculate analytics per minute instead of every transcation - 14400 at most per day per account
  WEBHOOK_FAST: 'WEBHOOK_FAST', // exclusive queue for the first webhook request
  PIX_TRANSACTION_LEDGER_DECOUPLED: 'PIX_TRANSACTION_LEDGER_DECOUPLED', // save transaction and notify webhook before writing to ledger
  PIX_OUT_API_ASYNC: 'PIX_OUT_API_ASYNC', // move pix out implementation in the api to a job to control concurrency
  LEDGER_INSERT_MANY: 'LEDGER_INSERT_MANY', // insert all ledger entries at once
  LEDGER_WITHOUT_REDIS_LOCK: 'LEDGER_WITHOUT_REDIS_LOCK', // remove redis lock and keep only mongodb unique lock
  LEDGER_QUEUE_PROCESSOR: 'LEDGER_QUEUE_PROCESSOR', // use a queue to process ledger entries without a lock
  HIDE_CUSTOMER_PAYER: 'HIDE_CUSTOMER_PAYER', // hide customer payer in customer loader

  INTERNAL_PAYMENT: 'INTERNAL_PAYMENT', // hide customer payer in customer loader
  OLD_SUBSCRIPTION: 'OLD_SUBSCRIPTION',
  FRAUD_VALIDATION: 'FRAUD_VALIDATION',
  SPLIT_WITH_SAME_CHARGE_VALUE: 'SPLIT_WITH_SAME_CHARGE_VALUE',
  USE_ACCOUNT_SPECIFIC_NAMES: 'USE_ACCOUNT_SPECIFIC_NAMES', // baas now can use their name instead of woovi name

  PIX_OUT_REDIS_LIMITS: 'PIX_OUT_REDIS_LIMITS', // use redis to store limits
  ALLOW_REVERSAL: 'ALLOW_REVERSAL', // allow reversal of pix transactions for companies
  ALLOW_AUTOMATIC_SANITY_FIXES: 'ALLOW_AUTOMATIC_SANITY_FIXES', // allow reversal of pix transactions for companies
  MED_FEE: 'MED_FEE', // chage fee for a new MED
  MOVEMENT_BATCH: 'MOVEMENT_BATCH', // allow batch excel import

  FORCE_TWO_FACTOR_COMPANY_LOGIN: 'FORCE_TWO_FACTOR_COMPANY_LOGIN', // force two factor in company

  COMPREFACE_DETECTION: 'COMPREFACE_DETECTION', // enable feature validate face detection in kyc
  COMPREFACE_DETECTION_HEAD_POSITION: 'COMPREFACE_DETECTION_HEAD_POSITION', // validate head position in face detection
  COMPREFACE_VERIFICATION: 'COMPREFACE_VERIFICATION', // enable feature validate face and document verification

  ACCEPT_DELAYED_PAYMENT: 'ACCEPT_DELAYED_PAYMENT', // accept payment when pacs 008 come later, if e2e time < charge expiration

  WITHDRAWAL_INCLUDE_FEE: 'WITHDRAWAL_INCLUDE_FEE',

  GET_ALL_TRANSACTION_COMPANY_BANK_ACCOUNT:
    'GET_ALL_TRANSACTION_COMPANY_BANK_ACCOUNT',
  GET_ALL_CHARGE_COMPANY_BANK_ACCOUNT: 'GET_ALL_CHARGE_COMPANY_BANK_ACCOUNT',

  USE_WEBHOOK_SERVICE: 'USE_WEBHOOK_SERVICE', // send webhooks to webhook service

  EMV_V2: 'EMV_V2', // use new EMV experimental
  EMV_REMOVE_CUSTOMER: 'EMV_REMOVE_CUSTOMER', // remove customer from emv

  VALIDATE_WEBHOOK_URL: 'VALIDATE_WEBHOOK_URL',

  HIDE_LEGACY_ACCOUNTS: 'HIDE_LEGACY_ACCOUNTS',
  SEND_EMAIL_TO_BLOCK_COMPANY_BANK_ACCOUNT:
    'SEND_EMAIL_TO_BLOCK_COMPANY_BANK_ACCOUNT',

  NEW_STATEMENT: 'NEW_STATEMENT', // new statement consuming from new analytics
  WALLET_LEDGER_STATEMENT: 'WALLET_LEDGER_STATEMENT',

  READ_WRITE_BLOCKINGS: 'READ_WRITE_BLOCKINGS',
  NEW_ANALYTICS: 'NEW_ANALYTICS',
  READ_ACCOUNT_LIMITS: 'READ_ACCOUNT_LIMITS',

  SEND_WEBHOOK_TO_BLOCK_COMPANY_BANK_ACCOUNT:
    'SEND_WEBHOOK_TO_BLOCK_COMPANY_BANK_ACCOUNT',
  ENABLE_LIMITATION_OF_VIEW_CHARGE_HISTORY:
    'ENABLE_LIMITATION_OF_VIEW_CHARGE_HISTORY',
} as const;
export type MODULES = (typeof MODULES)[keyof typeof MODULES];
